import { Stepper } from "../components/ui/stepper";
import { LandingLpForm } from "../components/lp/LandingLpForm";
import { LP_FAKE_FORM_STEPS } from "../lib/constants";

const NcLPPage = () => {
  return (
    <div>
      <img
        src="/assets/landing-page-grid-img.png"
        alt="background"
        className="fixed inset-x-0 h-[70dvh] opacity-5 select-none -z-40 w-full  object-cover mask-gradient-to-b object-top"
      />

      <Stepper initialStep={LP_FAKE_FORM_STEPS.STYLE}>
        <LandingLpForm />
      </Stepper>
    </div>
  );
};

export default NcLPPage;
